<template>
  <vs-card v-if="batch" :to="linkTo">
    <div>
      <v-row align="center">
        <v-col>
          <vs-text>{{ batchTitle }}</vs-text>
          <created-info
            :created-time="batch.created ?? undefined"
            :creator-sid="batch.createdBy ?? ''"
            text-type="subdued"
          />
        </v-col>
      </v-row>
      <div class="mt-2">
        <v-row dense>
          <v-col>
            <vs-text type="paragraph">
              <v-icon>mdi-calendar-month</v-icon>
              {{ formattedInvoiceDate }}
            </vs-text>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <vs-text
              v-if="batch.paymentTerms != null && batch.paymentTerms !== BatchPaymentTerms.Custom"
              type="paragraph"
            >
              <v-icon>mdi-receipt-clock</v-icon>
              {{ batch.paymentTerms && batchPaymentTermsString(batch.paymentTerms) }}
            </vs-text>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <vs-text type="paragraph">
              <v-icon>mdi-calendar-clock</v-icon>
              {{ formattedDueDate }}
            </vs-text>
          </v-col>
        </v-row>
      </div>
    </div>
  </vs-card>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { RouterLinkProps } from 'vue-router/types/router'
import VsCard from '@/components/vision/VsCard.vue'
import VsText from '@/components/vision/VsText.vue'
import { BatchPaymentTerms, batchPaymentTermsString, BatchSearchDto } from '@/models/batch'
import CreatedInfo from '@/components/common/CreatedInfo.vue'
import moment from 'moment'

type RouterLinkTo = RouterLinkProps['to']

const props = defineProps<{
  batch: BatchSearchDto
  linkTo: RouterLinkTo
}>()

const batchTitle = computed(
  () => `Batch #${props.batch?.batchNumber} · ${props.batch.customerName ?? '-'}`,
)

const formattedInvoiceDate = computed(() =>
  moment.utc(props.batch.batchDate).local().format('MMM DD YYYY'),
)

const formattedDueDate = computed(() =>
  props.batch.dueDate ? moment.utc(props.batch.dueDate).local().format('MMM DD YYYY') : '',
)
</script>
